export default "__VITE_ASSET__DxiVbNgi__"